import { useState } from "react";

/**
 * Step 2 — collects the 6-digit OTP and offers a resend timer.
 */
export default function OtpStep({ phone, err, loading, resendIn, onVerify, onResend, onChangeNumber }) {
  const [otp, setOtp] = useState("");

  return (
    <form
      onSubmit={(e) => { e.preventDefault(); onVerify(otp); }}
      className="space-y-4"
    >
      <div className="text-sm">
        <span className="text-muted-foreground">OTP sent to</span>{" "}
        <span className="font-medium">+91 {phone}</span>{" "}
        <button
          type="button"
          onClick={() => { setOtp(""); onChangeNumber(); }}
          className="underline text-[hsl(var(--secondary))] ml-2"
          data-testid="phone-otp-change-number"
        >
          change
        </button>
      </div>
      <label className="block">
        <span className="eyebrow block mb-2">6-digit OTP</span>
        <input
          type="text"
          inputMode="numeric"
          autoFocus
          maxLength={6}
          value={otp}
          onChange={(ev) => setOtp(ev.target.value.replace(/\D/g, ""))}
          placeholder="123456"
          className="input-dark w-full px-3 py-3 text-lg tracking-[0.4em] text-center font-mono"
          data-testid="phone-otp-code-input"
        />
      </label>
      {err && <div className="text-sm text-destructive" data-testid="phone-otp-error">{err}</div>}
      <button
        type="submit"
        disabled={loading || otp.length !== 6}
        className="btn-primary w-full py-3 text-sm"
        data-testid="phone-otp-verify-btn"
      >
        {loading ? "Verifying…" : "Verify OTP"}
      </button>
      <div className="text-xs text-muted-foreground text-center">
        {resendIn > 0 ? (
          <>Didn't get it? Resend in <span className="text-foreground">{resendIn}s</span></>
        ) : (
          <button type="button" onClick={onResend} className="underline text-[hsl(var(--secondary))]" data-testid="phone-otp-resend">
            Resend OTP
          </button>
        )}
      </div>
    </form>
  );
}
